import React from 'react';
import {string} from 'prop-types';
import classNames from 'classnames';
import {Nav} from '@sinclair-digital/sbg-storyline-components/src/components/Nav';
import {moduleParams} from '@sinclair-digital/sbg-storyline-sdk/lib/storyline/shapes';
import {logout} from '../../js/logout';
import classes from './BasePage.scss';

const moduleButtonShape = moduleParams.moduleButtons;

const HeaderMenu = ({className, username}) => (
    <div className={classNames(classes.HeaderMenu, className)}>
        {username && <span className="sda-header-welcome">Welcome, {username}</span>}
        <div className="sda-header-menu sda-user-menu">
            <button className="sda-header-menu-toggle fa-user" title="User Menu" />
            <ul className="sda-header-menu-options">
                <li>
                    <a id="sda-sign-out" onClick={logout}>
                        sign out
                    </a>
                </li>
            </ul>
        </div>
        <div className="sda-header-menu sda-help-menu">
            <button className="sda-header-menu-toggle fa-question-circle" title="Help Menu" />
            <ul className="sda-header-menu-options">
                <li>
                    <a href="/help/" title="Help" target="_blank" rel="noopener noreferrer">
                        help
                    </a>
                </li>
                <li>
                    <a
                        title="File a ticket"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://sinclairdigital.atlassian.net/servicedesk/customer/portal/2">
                        file a ticket
                    </a>
                </li>
            </ul>
        </div>
    </div>
);

HeaderMenu.propTypes = {
    className: string,
    username: string,
};

const LeftNav = ({className, menuItems = []}) => (
    <nav className={classNames(className, classes.LeftNav)}>
        <ul className="page-nav">
            {menuItems.map(navItem => (
                <Nav key={navItem.text} {...navItem} />
            ))}
        </ul>
    </nav>
);

LeftNav.propTypes = {
    className: string,
    menuItems: moduleButtonShape,
};

const BasePage = ({className, menuItems, username}) => {
    const classList = classNames(classes.BasePage, className);
    const navClasses = classNames('sda-nav-panel', 'panel-open', classes.navPanel);
    const adminClasses = classNames('adminMain', classes.adminMain);

    return (
        <div className={classList}>
            <div className="sda-app-notifications" />
            <div id="fb-root" />
            <header className="sda-app-header">
                <i className="sda-top-loader" />
                <div className="sda-brand">
                    <a className="sda-nav-toggle">
                        <div />
                        <div />
                        <div />
                    </a>
                    <a href="#home" className="sda-logo">
                        <span className="brand-gray">Story</span>
                        <span className="brand-red">Line</span>
                    </a>
                    <span id="sda-admin-header-view-title" className="sda-admin-header-view-title" />
                </div>
                <HeaderMenu className="sda-header-menus" username={username} />
            </header>
            <div id="admin-body" className="sda-app-body">
                <LeftNav className={navClasses} menuItems={menuItems} />
                <main id="admin-main" className={adminClasses} />
            </div>
            <div id="main-loader" className="main-loader" />
        </div>
    );
};

BasePage.propTypes = {
    className: string,
    menuItems: moduleButtonShape,
    username: string,
};

export default BasePage;
